export const GetCurrvoyageNew = {
  status: 0,
  data: {
    depportname_cn: '未知',
    depportname_en: '未知',
    depCountryCode: '未知',
    destportname_cn: '未知',
    destportname_en: '未知',
    deptime: '',
    desttime: '',
    navi_stat: '未知',
    navi_time: 0.0,
    navi_distance: 0.0,
    sog1: 0.0,
    sog2: 0.0,
    position: ' Yellow Sea|渤海海峡',
    depatbtime: '',
    destportzone: 0.0,
  },
}
